'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var quesk = _interopDefault(require('quesk'));

function seqr () {
  var queue = quesk();
  var api = {};

  api.then = function (fn) {
    if (fn && typeof fn === 'function') {
      queue.append({
        fn: fn,
        lock: false
      });
    }

    next(queue.first());

    return api
  };

  return api

  function next (el) {
    if (el && !el.lock) {
      el.lock = true;
      el.fn(done);
    }
  }

  function done () {
    var el = queue.first();

    if (el && el.lock) {
      queue.shift();
      next(queue.first());
    }
  }
}

module.exports = seqr;
//# sourceMappingURL=seqr.js.map
